import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AppConfig } from 'src/app/app.config';
import { PHBHPFeaturePackageInsitutionManagementService } from '../../ph-bhp-feature-package-insitution-management.service';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { TranslationKeys } from 'ph-bhp-localization'

@Component({
  selector: 'app-webkess-layout',
  templateUrl: './webkess-layout.component.html',
  styleUrls: ['./webkess-layout.component.css']
})
export class WebkessLayoutComponent implements OnInit {
  institutionData: any;
  institutionId = 0;
  isPackageEnabled = false;
  institutionDetailTabs = [];
  translationKeys: typeof TranslationKeys = TranslationKeys;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public translate: TranslateService,
    public config: AppConfig,
    private service: PHBHPFeaturePackageInsitutionManagementService,
    public layoutService: PHBHPLayoutPackageService
  ) { }

  ngOnInit() {
    this.institutionId = this.activatedRoute.snapshot.params.id;
    this.loadTabs();
    this.getInstitutionDetails();
  }

  loadTabs() {
    this.institutionDetailTabs = [
      {
        title: 'WEBKESS_INTEGRATION.SETTINGS',
        url: `./webKessSettings`
      },
      {
        title: 'WEBKESS_INTEGRATION.UPLOAD_TO_WEBKESS',
        url: `./exportWebKess`
      },
      {
        title: 'WEBKESS_INTEGRATION.REPORT',
        url: `./webKessReports`
      }
    ];
  }

  getInstitutionDetails() {
    this.layoutService.showLoader = true;
    this.service.GetInstitutionDetails(this.institutionId).subscribe((res: any) => {
      this.institutionData = res;
      this.isPackageEnabled = [2, 3, 6, 7].includes(this.institutionData.institution.institution.packageID);
      this.layoutService.showLoader = false;
    });
  }

  backToManageInstitution() {
    this.router.navigate(['institution']);
  }
}

